import { useCallback, useState } from 'react';

import type { LeadCardCheckboxItemData } from '@app/components/LeadCard/data';

import type { CheckboxChangeEvent } from 'antd/es/checkbox';

interface UseCheckboxSectionParams {
  onChange(itemId: LeadCardCheckboxItemData['id'], checked: boolean): void;
}

interface UseCheckboxSectionResult {
  isExpanded: boolean;
  toggleExpanded(): void;
  itemChangeHandler(
    itemId: LeadCardCheckboxItemData['id']
  ): (event: CheckboxChangeEvent) => void;
}

export const useCheckboxSection = ({
  onChange,
}: UseCheckboxSectionParams): UseCheckboxSectionResult => {
  // Блок свёрнут по умолчанию: пункты раскрывают, только чтобы поменять
  // настройки (us/11168).
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpanded = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  const itemChangeHandler = useCallback(
    (itemId: LeadCardCheckboxItemData['id']) =>
      ({ target: { checked } }: CheckboxChangeEvent) => {
        onChange(itemId, checked);
      },
    [onChange]
  );

  return { isExpanded, toggleExpanded, itemChangeHandler };
};
